import { op } from "libs/transaction";
import { createAction } from "./action";
import { getPointer } from "libs/schema";

/* -------------------------------------------------------------------------------------------------
 *  toggleFocusMode
 * -------------------------------------------------------------------------------------------------
 */

type ToggleFocusModeProps = {
  enableFocusMode: boolean;
};

export const toggleFocusMode = createAction<ToggleFocusModeProps>("toggleFocusMode.toggleFocusMode", {
  operations: async (props, context) => {
    return op.set(
      getPointer("user_settings", context.currentUserId),
      ["settings", "enable_focus_mode"],
      props.enableFocusMode,
    );
  },
  authorize: async () => {
    // Users are permitted to update their own user_settings record, and the current implementation
    // with `context.currentUserId` ensures that only this record can be updated, so no authorization is necessary.
  },
});

export const actions = {
  toggleFocusMode,
};
